import React from 'react';

const PageLanguages = () => {
  return (
    <h1>Page languages</h1>
  );
};

export default PageLanguages;
